(function () {
  "use strict";

  var runtime = document.querySelector("[data-ish-wear-runtime]");
  if (!runtime) return;
  var ORIGIN = "https://inshape-first-purchase-survey.mftwice.chatgpt.site";
  var VERSION = "first_purchase_wear_v3";
  var STORAGE_KEY = "inshape-wear-reward-v3-token";
  var SOURCE_KEY = "inshape-wear-reward-v3-source";
  var preview = document.body.dataset.wearPreview === "true" && ["localhost", "127.0.0.1"].includes(location.hostname);
  var token = "";
  var source = "evergreen_email";
  var reward = null;
  var requestBusy = false;
  var timer = null;
  var expiryTimer = null;
  var polls = 0;
  var copyButton = document.querySelector(".ishl-lprw__copy");
  var copyStatus = document.querySelector(".ishl-lprw__copy-status");
  var stateName = "loading";
  var completed = false;
  var offers = null;
  var offerError = false;
  var STAFF_KEY = "inshape-wear-staff-qa-v1";
  var staffMode = false;
  var staffAccess = null;
  var staffGrant = null;
  var staffApplyBusy = false;

  function validStaffAccess(access) {
    return Boolean(access && /^[A-Za-z0-9_-]{32,128}$/.test(access.token || "") && /^[A-Za-z0-9][A-Za-z0-9_-]{15,79}$/.test(access.runId || ""));
  }
  function validStaffGrant(grant) {
    var expiry = Date.parse(grant && grant.expiresAt || "");
    return staffMode && validStaffAccess(staffAccess) && grant && grant.scope === "existing-staff-reward" && grant.runId === staffAccess.runId
      && Number.isFinite(expiry) && expiry > Date.now() && expiry <= Date.now() + 30 * 60000;
  }
  function readStaffLaunch(early, fragment, publicDirect) {
    var direct = Boolean(early && early.direct) || fragment.has("staff_qa_token") || fragment.has("staff_qa_run");
    if (direct) {
      staffMode = true;
      staffAccess = { token: fragment.get("staff_qa_token") || early && early.token || "", runId: fragment.get("staff_qa_run") || early && early.runId || "" };
    }
    fragment.delete("staff_qa_token"); fragment.delete("staff_qa_run");
    try {
      if (direct || publicDirect) sessionStorage.removeItem(STAFF_KEY);
      if (!direct && !publicDirect) {
        var saved = sessionStorage.getItem(STAFF_KEY);
        if (saved) { staffMode = true; staffAccess = JSON.parse(saved); }
      }
      if (direct && validStaffAccess(staffAccess)) sessionStorage.setItem(STAFF_KEY, JSON.stringify(staffAccess));
    } catch (_) { if (!direct && !publicDirect) staffMode = true; }
    if (staffMode) { token = ""; try { sessionStorage.removeItem(STORAGE_KEY); sessionStorage.removeItem(SOURCE_KEY); } catch (_) {} }
  }

  function validToken(value) {
    return typeof value === "string" && value.length >= 16 && value.length <= 1500 && /^[A-Za-z0-9_-]+\.[A-Za-z0-9_-]+$/.test(value);
  }

  function readLaunch() {
    var early = window.__inshapeWearRewardLaunch;
    var staffEarly = window.__inshapeWearStaffQaLaunch;
    try { delete window.__inshapeWearStaffQaLaunch; } catch (_) {}
    try { delete window.__inshapeWearRewardLaunch; } catch (_) {}
    var url = new URL(location.href);
    var fragment = new URLSearchParams(url.hash.slice(1));
    var direct = fragment.has("token") || Boolean(early && early.direct);
    var staffDirect = Boolean(staffEarly && staffEarly.direct) || fragment.has("staff_qa_token") || fragment.has("staff_qa_run");
    readStaffLaunch(staffEarly, fragment, direct);
    var value = fragment.has("token") ? fragment.get("token") : early && early.token || "";
    var requestedSource = fragment.get("source") || early && early.source;
    if (direct || staffDirect) {
      fragment.delete("token");
      fragment.delete("source");
      url.hash = fragment.toString();
      history.replaceState(history.state, "", url.pathname + url.search + url.hash);
    }
    try {
      if (direct) {
        sessionStorage.removeItem(STORAGE_KEY);
        sessionStorage.removeItem(SOURCE_KEY);
        if (validToken(value)) {
          token = value;
          source = requestedSource === "campaign_email" ? "campaign_email" : "evergreen_email";
          sessionStorage.setItem(STORAGE_KEY, token);
          sessionStorage.setItem(SOURCE_KEY, source);
        }
      } else {
        value = sessionStorage.getItem(STORAGE_KEY) || "";
        if (validToken(value)) token = value;
        source = sessionStorage.getItem(SOURCE_KEY) === "campaign_email" ? "campaign_email" : "evergreen_email";
      }
    } catch (_) {
      if (direct && validToken(value)) {
        token = value;
        source = requestedSource === "campaign_email" ? "campaign_email" : "evergreen_email";
      }
    }
    if (staffMode) { token = ""; return; }
    if (preview) {
      token = new URL(location.href).searchParams.get("state") === "missing" ? "" : "review-only-local";
      source = "campaign_email";
    }
  }

  function money(value) {
    return new Intl.NumberFormat("en-US", { style: "currency", currency: "USD" }).format(value);
  }

  function classify(record) {
    if (!record || record.ok !== true || record.questionnaire !== "wear" || record.surveyVersion !== VERSION) return "unavailable";
    if (staffMode && (record.isTest !== true || !validStaffGrant(record.staffQa))) return "unavailable";
    if (record.isTest === true && !staffMode || record.reward && ["test", "preview", "qa_pending"].includes(record.reward.status)) return "test";
    if (record.completed !== true) return "incomplete";
    var candidate = record.reward;
    if (!candidate) return "pending";
    if (candidate.redeemed === true || candidate.status === "redeemed" || candidate.status === "used") return "redeemed";
    var expiry = Date.parse(candidate.expiresAt || "");
    if (candidate.status === "expired" || Number.isFinite(expiry) && expiry <= Date.now()) return "expired";
    if (candidate.status === "pending") return "pending";
    if (candidate.status !== "active" || candidate.amount !== 30 || candidate.minimum !== 0 || candidate.includesFreeShipping !== false) return "unavailable";
    var issued = Date.parse(candidate.issuedAt || "");
    var codeValid = /^FIRST30-[A-Z0-9]{16}$/.test(candidate.code || "") || preview && ["DEMOONLY30", "DEMO-NOT-A-COUPON"].includes(candidate.code);
    if (!codeValid || !Number.isFinite(issued) || !Number.isFinite(expiry) || issued > Date.now() + 1000 || Math.abs(expiry - issued - 14 * 86400000) > 1000) return "unavailable";
    return "active";
  }

  function surveyLink() {
    var url = new URL("/wear-survey.html", ORIGIN);
    url.searchParams.set("token", token);
    url.searchParams.set("source", source);
    if (completed) url.searchParams.set("mode", "edit");
    return url.href;
  }

  function applyLink(pack) {
    if (staffMode) return "#";
    var url = new URL("/api/apply", ORIGIN);
    url.searchParams.set("token", token);
    url.searchParams.set("pack", pack);
    return url.href;
  }

  function renderState(status) {
    stateName = status;
    var active = status === "active";
    document.documentElement.classList.toggle("ish-wear-no-reward", !active);
    document.documentElement.classList.toggle("ish-wear-has-reward", active);
    runtime.hidden = active;
    runtime.dataset.state = status;
    var headings = {
      loading: "Opening your reward…",
      pending: "Your reward is still loading.",
      redeemed: "This reward has already been used.",
      expired: "This reward has expired.",
      missing: "Open your reward link again.",
      unavailable: "Open your reward link again.",
      incomplete: "Finish your survey first.",
      test: "Preview only. No reward is available."
    };
    var descriptions = {
      loading: "",
      pending: "Your answers are saved. Your original reward will appear here when it is ready.",
      redeemed: "Check your reward email or contact us if you think this is incorrect.",
      expired: "Check your reward email or contact us if you think this is incorrect.",
      missing: "Open the personal link in your reward email.",
      unavailable: "Open the personal link in your reward email. If it still does not load, contact us.",
      incomplete: "Your saved answers are waiting in your personal survey.",
      test: "This test link cannot be used to shop with a real coupon."
    };
    runtime.querySelector("[data-ish-recovery-title]").textContent = headings[status] || headings.unavailable;
    runtime.querySelector("[data-ish-recovery-copy]").textContent = descriptions[status] || "";
    var retry = runtime.querySelector("[data-ish-wear-refresh]");
    retry.hidden = !token || !["pending", "unavailable"].includes(status);
    var back = runtime.querySelector("[data-ish-wear-back]");
    back.hidden = staffMode || !token || ["missing", "loading", "test"].includes(status);
    back.href = preview ? "#" : surveyLink();
    document.querySelectorAll(".ishl-lpk__card").forEach(function (card) {
      var pack = card.dataset.wearPack;
      var offer = offers && offers.find(function (item) { return item.pack === pack; });
      var canShop = active && Boolean(offer && offer.available);
      card.href = canShop && !preview ? applyLink(pack) : "#";
      card.setAttribute("aria-disabled", canShop ? "false" : "true");
    });
    document.querySelectorAll(".ishl-lprw__code").forEach(function (node) { node.textContent = active ? reward.code : ""; });
    if (copyButton) {
      copyButton.disabled = !active;
      copyButton.dataset.code = active ? reward.code : "";
    }
    if (staffMode && !document.querySelector("[data-ish-wear-staff-notice]")) {
      var notice = document.createElement("aside");
      notice.setAttribute("data-ish-wear-staff-notice", "true");
      notice.setAttribute("role", "status");
      notice.textContent = "Staff QA · original test reward. Customer launch remains paused.";
      notice.style.cssText = "padding:14px 20px;background:#fff7d6;color:#252525;text-align:center;font:600 14px/1.5 sans-serif";
      document.body.insertBefore(notice, document.body.firstChild);
    }
    if (!active) return;
    var grid = document.querySelector(".ishl-lpk__grid");
    if (grid) grid.hidden = !offers;
    var expiry = new Intl.DateTimeFormat("en-US", { month: "long", day: "numeric", year: "numeric" }).format(new Date(reward.expiresAt));
    var fine = document.querySelector("[data-ish-wear-expiry]");
    if (fine) fine.textContent = "Valid through " + expiry + ".";
    document.querySelectorAll(".ishl-lpk__card").forEach(function (card) {
      var offer = offers && offers.find(function (item) { return item.pack === card.dataset.wearPack; });
      if (!offer) return;
      var subtotal = offer.price / 100;
      var prefix = offer.variable ? "From " : "";
      var pack = Number(card.dataset.wearPack);
      if (!Number.isFinite(subtotal) || ![3, 5].includes(pack)) return;
      var applied = Math.min(subtotal, reward.amount);
      card.querySelector(".ishl-lpk__pack").textContent = prefix + money(subtotal);
      card.querySelector(".ishl-lpk__reward").textContent = "−" + money(applied);
      card.querySelector(".ishl-lpk__now").textContent = prefix + money(Math.max(0, subtotal - applied));
      card.querySelector(".ishl-lpk__aftertag").textContent = offer.variable ? "Final price depends on your color and size; verified in cart" : "After your $30 reward, verified in cart";
      card.querySelector(".ishl-lpk__btn").textContent = offer && !offer.available ? "Currently unavailable" : "Choose the " + pack + " pack →";
    });
    clearTimeout(expiryTimer);
    var deadline = staffMode ? Math.min(Date.parse(reward.expiresAt), Date.parse(staffGrant.expiresAt)) : Date.parse(reward.expiresAt);
    expiryTimer = setTimeout(function () { renderState(staffMode && !validStaffGrant(staffGrant) ? "unavailable" : "expired"); }, Math.min(2147483647, Math.max(1, deadline - Date.now())));
    var offerStatus = document.querySelector("[data-ish-wear-offers-status]");
    if (offerStatus) offerStatus.textContent = offerError ? "Pack prices could not load. Refresh to try again." : offers ? "" : "Loading current pack prices…";
  }

  async function getStaffJson(action, pack) {
    if (!validStaffAccess(staffAccess)) throw new Error("Staff check unavailable");
    var url = new URL("/api/wear-staff-qa", ORIGIN);
    url.searchParams.set("action", action);
    if (pack) url.searchParams.set("pack", pack);
    var response = await fetch(url.href, { method: "GET", credentials: "omit", cache: "no-store", referrerPolicy: "no-referrer",
      headers: { Accept: "application/json", "X-InShape-Wear-Staff-QA": staffAccess.token, "X-InShape-Wear-Staff-Run": staffAccess.runId }, signal: AbortSignal.timeout(12000) });
    if (!response.ok) throw new Error("Staff check unavailable");
    return response.json();
  }

  async function getJson(path, personal) {
    if (staffMode && path === "response") return getStaffJson("response");
    var controller = new AbortController();
    var timeout = setTimeout(function () { controller.abort(); }, 12000);
    try {
      var url = new URL("/api/" + path, ORIGIN);
      if (personal) url.searchParams.set("token", token);
      var response = await fetch(url.href, { method: "GET", credentials: "omit", cache: "no-store", referrerPolicy: "no-referrer", headers: { Accept: "application/json" }, signal: controller.signal });
      if (!response.ok) throw new Error("Reward unavailable");
      return await response.json();
    } finally { clearTimeout(timeout); }
  }

  async function loadOffers() {
    if (offers) return;
    try {
      var result = await getJson("offers", false);
      if (result.ok !== true || !Array.isArray(result.products) || result.products.length !== 2) throw new Error("Offers unavailable");
      var seen = new Set();
      var expected = { "3": "3-pack-inshape-beaters-size-up", "5": "5-pack-inshape-compression-tanks-1" };
      result.products.forEach(function (product) {
        if (!expected[product.pack] || product.handle !== expected[product.pack] || seen.has(product.pack) || !Number.isSafeInteger(product.price) || product.price < 0 || typeof product.available !== "boolean" || typeof product.variable !== "boolean") throw new Error("Offers unavailable");
        seen.add(product.pack);
      });
      offers = result.products;
      offerError = false;
    } catch (_) { offerError = true; }
    if (stateName === "active") renderState("active");
  }

  async function loadReward() {
    if (!token && !staffMode) { renderState("missing"); return; }
    if (requestBusy) return;
    requestBusy = true;
    clearTimeout(timer);
    try {
      var record = await getJson("response", true);
      staffGrant = staffMode ? record.staffQa || null : null;
      completed = record.completed === true;
      reward = record.reward || null;
      var status = classify(record);
      renderState(status);
      if (status === "active") await loadOffers();
      if (status === "pending" && polls < 60) {
        polls += 1;
        timer = setTimeout(loadReward, 5000);
      }
    } catch (_) {
      reward = null;
      renderState("unavailable");
    } finally { requestBusy = false; }
  }

  runtime.querySelector("[data-ish-wear-refresh]").addEventListener("click", loadReward);
  runtime.querySelector("[data-ish-wear-back]").addEventListener("click", function (event) { if (preview) event.preventDefault(); });
  if (copyButton) copyButton.addEventListener("click", async function () {
    if (stateName !== "active" || !reward || Date.parse(reward.expiresAt) <= Date.now() || staffMode && !validStaffGrant(staffGrant)) return;
    try {
      await navigator.clipboard.writeText(reward.code);
      copyButton.textContent = "Copied!";
      if (copyStatus) copyStatus.textContent = "Code copied.";
    } catch (_) {
      if (copyStatus) copyStatus.textContent = "Select the code and copy it manually.";
    }
    setTimeout(function () { copyButton.textContent = "Copy code"; }, 1800);
  });
  document.querySelectorAll(".ishl-lpk__card").forEach(function (card) {
    card.addEventListener("click", async function (event) {
      if (preview || stateName !== "active" || card.getAttribute("aria-disabled") === "true" || !reward || Date.parse(reward.expiresAt) <= Date.now()) {
        event.preventDefault();
        if (preview) {
          var demoStatus = document.querySelector("[data-wear-review-status]");
          if (demoStatus) demoStatus.textContent = "Demo only. No coupon, cart or order was created.";
        }
        else if (reward && Date.parse(reward.expiresAt) <= Date.now()) renderState("expired");
        return;
      }
      if (staffMode) {
        event.preventDefault();
        if (staffApplyBusy || !validStaffGrant(staffGrant)) { if (!validStaffGrant(staffGrant)) renderState("unavailable"); return; }
        staffApplyBusy = true;
        try {
          var result = await getStaffJson("apply", card.dataset.wearPack);
          if (result.ok !== true || result.isTest !== true || !validStaffGrant(result.staffQa)) throw new Error("Staff check unavailable");
          var target = new URL(result.redirectUrl);
          var paths = { "3": "/products/3-pack-inshape-beaters-size-up", "5": "/products/5-pack-inshape-compression-tanks-1" };
          if (target.origin !== "https://in-shape.co" || target.username || target.password || target.hash
            || target.pathname !== "/discount/" + encodeURIComponent(reward.code) || target.searchParams.get("redirect") !== paths[card.dataset.wearPack]
            || Array.from(target.searchParams.keys()).length !== 1) throw new Error("Staff destination unavailable");
          // This explicit staff lane never calls the public apply/response routes.
          location.assign(target.href);
        } catch (_) { renderState("unavailable"); }
        finally { staffApplyBusy = false; }
        return;
      }
      try {
        sessionStorage.removeItem("inshape-survey-reward-v1");
        sessionStorage.removeItem("inshape-survey-reward-token-v1");
        sessionStorage.setItem("inshape-active-reward-journey-v1", "unique");
      } catch (_) {}
    });
  });
  document.querySelectorAll(".ishl .reveal, .ishl .stag").forEach(function (node) { node.classList.add("in"); });
  readLaunch();
  renderState("loading");
  loadReward();
})();
